import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "../employees/index.css";
import { Moment } from "moment";
import { getBookData } from "../../../apis/auth";
import { formatDate } from "../../../environment";

const BankList = () => {


  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  type EmployeeResponse = {
    title: string;
    CurrentRole: string;
    amount: number;
    description: string;
    createdAt: string;
    id: any;
    Status: string;
    cash_bank: string
    key: number
  };

  type EmployeeData = {
    key: number;
    Date: any;
    Name: string;
    id: any;
    amount: number;
    address: string;
    cash_bank: string
  };
  const loginData = sessionStorage.getItem("info");
  const BankData = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        user_id: JSON.parse(loginData).user_id,
        cash_bank: "cash"
      };
      const response = await getBookData(data);
      let employeeData = response?.data?.expenses?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          date: item.createdAt || "Not Assigned",
          Name: `${item.title}`,
          amount: item.amount,
          address: item.description || "Not Assigned",
          id: item.id,
          cash_bank: item.cash_bank,
        })
      );

      if (searchQuery) {
        employeeData = employeeData.filter((item) =>
          item.Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.cash_bank.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    BankData();
  }, [searchQuery, state]);

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{formatDate(text)}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.Name}</div>
            </p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },


    {
      title: "Description",
      dataIndex: "address",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{text}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Cash Or Bank",
      dataIndex: "cash_bank",
      render: (text: string) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{text}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record?.amount}</div>
            </p>
          </div>
        </div>
      ),
    },
  ];

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };


  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name\Mobile"
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {allEmployeeData && allEmployeeData.length > 0 && (
                <Table
                  dataSource={allEmployeeData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankList;